import * as React from 'react'
export default class CloseBtn extends React.Component<{
  onClick: () => unknown
}> {
  render(): React.ReactElement<'button'> {
    return (
      <button onClick={this.props.onClick}>
        <svg height="100%" width="100%" viewBox="0 0 50 50">
          <g fill="currentColor">
            <path d="M32.217 19.707a1 1 0 1 0-1.414-1.414l-12.51 12.51a1 1 0 0 0 1.414 1.414l12.51-12.51z" />
            <path d="M30.803 32.217a1 1 0 0 0 1.414-1.414l-12.51-12.51a1 1 0 0 0-1.414 1.414l12.51 12.51z" />
          </g>
        </svg>
      </button>
    )
  }
}
